export const REMOVABLE_ALERTS = {
  WEBSOCKET_NOT_CREATED: 'website-not-created',
};

export const NON_REMOVABLE_ALERTS = {
  DOMAIN_NOT_CONFIGURED: 'domain-not-configured',
};
